import { LoadingButton } from '@mui/lab';

interface SingleButtonProps {
  isMobile: boolean;
  onClick: () => any;
  title: string;
  loading?: boolean;
  disabled?: boolean;
}

export const SingleButton = ({ isMobile, onClick, title, loading = false, disabled = false }: SingleButtonProps) => {
  return (
    <LoadingButton
      sx={{ color: 'white' }}
      color="primary"
      variant="contained"
      size={isMobile ? 'small' : 'medium'}
      onClick={onClick}
      loading={loading}
      disabled={disabled}
    >
      {title}
    </LoadingButton>
  );
};
